import React, { useState, useEffect } from "react";
import { ExportVendorPDFButton } from "./exportVendorPDF";
import { Box, Grid, Typography, Divider } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import {
  BusinessOutlined,
  CreditCardOutlined,
  AttachFileOutlined,
  StickyNote2Outlined,
} from "@mui/icons-material";
import { getRoleFromStorage } from "../../utils/auth";
import ActionButtons from "./ActionButtons";
import { api_path } from "../../shared.js";
import { updateStatus } from "../../utils/UpdateStatus.js";
import {
  PageHeader,
  SectionCard,
  FieldItem,
  MetricCard,
  FileGroup,
} from "./RegistrationShared";

export default function VendorRegisterDetailView(props) {
  const [searchParams] = useSearchParams();
  const job_id = searchParams.get("id");
  const ROLE = getRoleFromStorage();

  const [form, setForm] = useState({});
  const [files, setFiles] = useState({});
  const [approvalStatus, setApprovalStatus] = useState(null);

  useEffect(() => {
    if (job_id) fetchData();
  }, [job_id]);

 const fetchData = async () => {
  const res = await fetch(`${api_path}/customer/get-vendorRegistration.php?id=${job_id}`);
  const result = await res.json();
  const data = result.data || {};
  
  // handle ทั้ง 2 กรณี — มี vendorInfo หรือไม่มี
  const vendor = data.vendorInfo || data.requestInfo || {};

  setApprovalStatus(data.approval_status);
  setForm({
    date:         vendor.date || vendor.create_date,
    vendorCode:   vendor.vendorCode   || vendor.codeNo,
    create_by:    vendor.create_by,
    status_name:  data.status_name,
    nameTH:       vendor.vendorNameTH || vendor.name,
    nameEN:       vendor.vendorNameEN,
    address1:     vendor.address1     || vendor.address,
    address2:     vendor.address2,
    taxId:        vendor.taxId,
    businessType: vendor.businessType,
    tel:          vendor.tel,
    ext:          vendor.ext,
    mobile:       vendor.mobile,
    otherContact: vendor.otherContact || vendor.contactPerson,
    paymentType:  vendor.paymentType,
    creditTerm:   vendor.creditTerm,
    remark:       vendor.remark,
  });
  setFiles(result.files || {});
};

  const show = (value) => {
    if (value === 0) return "ไม่มี";
    if (value === "transfer") return "โอนเงิน";
    if (value === "cheque") return "เช็ค";
    return value || "–";
  };


  const onSubmitForm = React.useCallback(({ STATUS }) => {

    console.log("props.UserID:", props.UserID);
    console.log("localStorage USER_ID:", localStorage.getItem("USER_ID"));

    swal({ title: "Are you sure to send data?", icon: "info", dangerMode: false, buttons: true })
      .then((isConfirm) => {
        if (isConfirm) {
          updateStatus({ JOB_ID: job_id, JOB_TYPE: "VENDOR", STATUS, REMARK: "", REASON_ID: "", REASON_NAME: "", USER_ID: props.UserID || JSON.parse(localStorage.getItem("USER_ID")) });
        }
      });
  }, [job_id, props.UserID]);

  const onEditButtonClick = React.useCallback((e) => {
    window.open(`/s-crm/CustomerRegisterForm?id=${e.row.key}&type=${e.row?.data?.SourceID}`, "_blank");
  }, []);

  const hasFiles = files.COMPANY_PROFILE?.length || files.AGREEMENT?.length;

  return (
    <Box sx={{ p: 3, maxWidth: 900 }}>

      <PageHeader
        title="รายละเอียดการบัญชีผู้ขาย/ผู้ให้บริการรายใหม่"
        createBy={form.create_by}
        date={form.createDate}
        approvalStatus={approvalStatus}
        statusName={form.status_name}
      />

      <SectionCard icon={<BusinessOutlined fontSize="small" />} title="ข้อมูลผู้ขาย/ผู้ให้บริการ">
        <Grid container spacing={2}>
          <FieldItem label="รหัสผู้ขาย/ผู้ให้บริการ" value={form.vendorCode} />
          <FieldItem label="วันที่" value={form.date} />
          <FieldItem label="ชื่อผู้ขาย/ผู้ให้บริการ (TH)" value={form.nameTH} xs={12} />
          <FieldItem label="ชื่อผู้ขาย/ผู้ให้บริการ (EN)" value={form.nameEN} xs={12} />
          <FieldItem label="สถานที่ตั้ง" value={form.address1} xs={12} />
          <FieldItem label="เลขประจำตัวผู้เสียภาษี" value={form.taxId} />
          <FieldItem label="ประเภทธุรกิจ" value={form.businessType} />
          <FieldItem label="โทรศัพท์" value={form.tel} />
          <FieldItem label="เบอร์ต่อ" value={form.ext} />
          <FieldItem label="มือถือ" value={form.mobile} />
          <FieldItem label="ช่องทางการติดต่ออื่นๆ" value={form.otherContact} xs={12} />
        </Grid>
      </SectionCard>

      <SectionCard icon={<CreditCardOutlined fontSize="small" />} title="เงื่อนไขการชำระเงิน">
        <Grid container spacing={1.5}>
          <Grid item xs={6} sm={4}>
            <MetricCard label="เงื่อนไขการชำระเงิน" value={show(form.paymentType)} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <MetricCard label="เครดิตเทอม" value={form.creditTerm} unit="วัน" />
          </Grid>
        </Grid>
      </SectionCard>

      {form.remark && (
        <SectionCard icon={<StickyNote2Outlined fontSize="small" />} title="หมายเหตุ">
          <Typography variant="body2" color="text.primary" sx={{ whiteSpace: "pre-wrap" }}>
            {form.remark}
          </Typography>
        </SectionCard>
      )}

      {hasFiles && (
        <SectionCard icon={<AttachFileOutlined fontSize="small" />} title="เอกสารประกอบการพิจารณา">
          <FileGroup label="เอกสารบริษัท" files={files.COMPANY_PROFILE} />
          <FileGroup label="สัญญา" files={files.AGREEMENT} />
        </SectionCard>
      )}
  <ExportVendorPDFButton form={form} files={files} />
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <ActionButtons ID={job_id} TYPE="VENDOR" ROLE={ROLE} STATUS={approvalStatus} onEdit={onEditButtonClick} onSubmit={onSubmitForm} />
      </Box>
    </Box>
  );
}
